import { BRAND_SECONDARY } from "../../../utils/Styles";
import * as React from 'react';
import './stepper.css';

export interface StepperProps {
  data: Array<{
    title: string;
    content: React.ReactNode;
  }>;
  activeStep: number;
  activeColor?: string;
  inActiveColor?: string;
}

const Stepper: React.FC<StepperProps> = (props) => {
  // local state
  //   const [activeStep, setActiveStep] = React.useState(props.activeStep || 0);

  // local hooks
  //   React.useEffect(() => {
  //     setActiveStep(props.activeStep);
  //   }, [props.activeStep]);

  // local variable
  const dataLength = props.data.length;
  const activeColor = props.activeColor || BRAND_SECONDARY;
  const inActiveColor = props.inActiveColor || 'rgba(0, 0, 0, 0.38)';
  const activeStep = props.activeStep || 0;

  return (
    <React.Fragment>
      <div className='stepper-main-container'>
        {props.data.map((d, index) => {
          return (
            <div key={index}>
              <div className='header-container'>
                {index >= activeStep && (
                  <span
                    className='header-icon-container'
                    style={{
                      backgroundColor:
                        activeStep >= index ? activeColor : inActiveColor,
                    }}>
                    <span className='header-icon-label'>{index + 1}</span>
                  </span>
                )}
                {index < activeStep && <CheckMark color={activeColor} />}
                <span className='header-label'>{d.title}</span>
              </div>
              {index === activeStep && (
                <div
                  className={
                    'content-container ' +
                    (index === dataLength - 1 ? 'border-none' : '')
                  }>
                  {d.content}
                  <div className='p-16'></div>
                </div>
              )}
              {index !== dataLength - 1 && index !== activeStep && (
                <div className='content-empty-container'></div>
              )}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

const CheckMark: React.FC<{ color: string }> = ({ color }) => {
  return (
    <span>
      <svg
        focusable='false'
        viewBox='0 0 24 24'
        height='30px'
        width='30px'
        aria-hidden='true'>
        <path
          fill={color}
          d='M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z'></path>
      </svg>
    </span>
  );
};

export default Stepper;
